"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _components = require("@insided/shared/services/algolia/components");

var _Article = _interopRequireDefault(require("@insided/destination/icons/Article"));

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Answer = _interopRequireDefault(require("@insided/destination/icons/Answer"));

var _Discussion = _interopRequireDefault(require("@insided/destination/icons/Discussion"));

var _Bug = _interopRequireDefault(require("@insided/destination/icons/Bug"));

var _Idea = _interopRequireDefault(require("@insided/destination/icons/Idea"));

var _ProductUpdate = _interopRequireDefault(require("@insided/destination/icons/ProductUpdate"));

var _Link = _interopRequireDefault(require("./Link"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _common = require("@insided/shared/utils/common");

var eventTracker = function eventTracker(item, topicType, idx) {
  _publish.default.trackEvent('userevent', {
    type: 'Topic Clicked',
    topic_title: item.title,
    topic_url: item.topic_url,
    topic_position: idx + 1,
    // to start index from 1 instead of 0, added +1
    topic_topic_type: topicType,
    click_source: 'Topic creation suggestion'
  });
};

var getTopicType = function getTopicType(hit) {
  if (hit.is_article) {
    return 'article';
  } else if (hit.is_ideation) {
    return 'ideation';
  } else if (hit.has_answer) {
    return 'answer';
  } else if (hit.content_type === 'question') {
    return 'question';
  } else if (hit.content_type === 'productUpdate') {
    return 'productUpdate';
  }

  return 'conversation';
};

var SuggestedTopicsList = function SuggestedTopicsList(_ref) {
  var hits = _ref.hits;

  var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

  var topicIcons = {
    question: (0, _preact.h)(_Question.default, null),
    article: (0, _preact.h)(_Article.default, null),
    answer: (0, _preact.h)(_Answer.default, null),
    conversation: isBugContentTypeEnabled ? (0, _preact.h)(_Bug.default, null) : (0, _preact.h)(_Discussion.default, null),
    productUpdate: (0, _preact.h)(_ProductUpdate.default, null),
    ideation: (0, _preact.h)(_Idea.default, null)
  };
  return (0, _preact.h)("ul", {
    className: "topic-create_suggestions-list"
  }, hits.map(function (hit, idx) {
    var topicType = getTopicType(hit);
    return (0, _preact.h)("li", {
      key: hit.topic_url
    }, (0, _preact.h)("a", {
      onClick: function onClick() {
        return eventTracker(hit, topicType, idx);
      },
      className: "topic-create_suggestions-item",
      href: (0, _absoluteUrlRuntime.resolveUrl)(hit.topic_url),
      rel: "noreferrer",
      target: "_blank"
    }, (0, _preact.h)("span", {
      className: "topic-create_suggestions_type-icon"
    }, topicIcons[topicType]), (0, _preact.h)("span", {
      className: "topic-create_suggestions-item-text"
    }, (0, _preact.h)(_components.Highlight, {
      attribute: "title",
      hit: hit,
      tagName: "strong"
    })), (0, _preact.h)("span", {
      className: "topic-create_suggestions_link-icon"
    }, (0, _preact.h)(_Link.default, null))));
  }));
};

var _default = SuggestedTopicsList;
exports.default = _default;